import React from "react";
import { Button, DatePicker, Form, Input, Select, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import Heading from "../../../Components/Heading/Heading";
import {
  useAddReservationCollectionMutation,
  useGetBranchesQuery,
  useGetSellersQuery,
} from "../../../redux/Service/api";

const { Option } = Select;

const CollectReservation: React.FC = () => {
  const [form] = Form.useForm();

  const { data: branchesData } = useGetBranchesQuery(undefined);
  const { data: sellersData } = useGetSellersQuery(undefined);

  const [addReservationCollection, { isLoading }] =
    useAddReservationCollectionMutation();

  const branches = branchesData?.ResponseObject || [];
  const sellers = sellersData?.ResponseObject || [];

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        BranchId: values.BranchId,
        DocDate: values.DocDate.format("YYYY-MM-DDT00:00:00"),
        Notes: values.Notes,
        FinCashDets: [
          {
            SideType: 0,
            // SideId: 1,
            Value: values.Value,
            ValueTafqit: values.ValueTafqit,
            // CurrId: 1,
            CurrRate: 1,
            SafeType: 0,
            // SafeId: 1,
            SellerId: values.SellerId,
            // CostID: "",
            Notes: values.DetailNotes,
          },
        ],
      };

      const response = await addReservationCollection(requestBody);
      if (response?.data) {
        message.success("تم تحصيل الحجز بنجاح");
        form.resetFields();
      }
    } catch (error) {
      console.error("Error collecting reservation:", error);
      message.error("Failed to collect reservation. Please try again.");
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error("Failed:", errorInfo);
    message.error("Please complete all required fields.");
  };

  return (
    <div>
      <Heading heading="تحصيل حجز" />
      <div className="container grid grid-cols-1 gap-0">
        <Form
          form={form}
          name="collectReservation"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="form-grid"
        >
          <Form.Item
            label="الفرع"
            name="BranchId"
            rules={[{ required: true, message: "يرجى اختيار الفرع" }]}
          >
            <Select size="large" placeholder="اختر الفرع">
              {branches.map((branch: any) => (
                <Option key={branch.BranchID} value={branch.BranchID}>
                  {branch.BranchName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="تاريخ المستند"
            name="DocDate"
            rules={[{ required: true, message: "يرجى اختيار تاريخ المستند" }]}
          >
            <DatePicker size="large" className="w-full" />
          </Form.Item>

          <Form.Item
            label="القيمة"
            name="Value"
            rules={[{ required: true, message: "يرجى إدخال القيمة" }]}
          >
            <Input size="large" type="number" />
          </Form.Item>

          <Form.Item
            label="القيمة التفقيطية"
            name="ValueTafqit"
            rules={[{ required: true, message: "يرجى إدخال القيمة التفقيطية" }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            label="البائع"
            name="SellerId"
            rules={[{ required: true, message: "يرجى اختيار البائع" }]}
          >
            <Select size="large" placeholder="اختر البائع">
              {sellers.map((seller: any) => (
                <Option key={seller.SellerID} value={seller.SellerID}>
                  {seller.SellerName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="ملاحظات" name="Notes">
            <TextArea size="large" rows={2} />
          </Form.Item>

          <Form.Item label="تفاصيل الملاحظات" name="DetailNotes">
            <TextArea size="large" rows={2} />
          </Form.Item>

          <Form.Item label="" name="any">
            {/* <TextArea size="large" rows={2} /> */}
          </Form.Item>

          <div className="flex ">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={isLoading}
            >
              حفظ
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CollectReservation;
